var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "force-google-binding-dialog",
      attrs: {
        title: "安全验证 - 绑定Google身份验证器",
        visible: _vm.visible,
        width: "500px",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "show-close": false,
        center: "",
        "before-close": _vm.handleClose,
        "append-to-body": true,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "binding-content" }, [
        _c(
          "div",
          { staticClass: "info-text" },
          [
            _c("el-alert", {
              attrs: {
                title: "为了您的账户安全，首次登录必须绑定Google身份验证器",
                type: "warning",
                closable: false,
                "show-icon": "",
              },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "step-content" }, [
          _vm.currentStep === 1
            ? _c(
                "div",
                { staticClass: "qr-step" },
                [
                  _c("h3", [_vm._v("步骤 1: 扫描二维码")]),
                  _c("p", { staticClass: "step-desc" }, [
                    _vm._v("使用Google身份验证器扫描下方二维码"),
                  ]),
                  _c("div", { staticClass: "qr-container" }, [
                    _vm.qrurl
                      ? _c("img", {
                          attrs: { src: _vm.qrurl, alt: "Google验证码二维码" },
                        })
                      : _c("div", { staticClass: "loading" }, [
                          _c("i", { staticClass: "el-icon-loading" }),
                          _c("span", [_vm._v("生成二维码中...")]),
                        ]),
                  ]),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-top": "20px" },
                      attrs: { type: "primary", disabled: !_vm.qrurl },
                      on: { click: _vm.nextStep },
                    },
                    [_vm._v(" 下一步 ")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.currentStep === 2
            ? _c(
                "div",
                { staticClass: "verify-step" },
                [
                  _c("h3", [_vm._v("步骤 2: 输入验证码")]),
                  _c("p", { staticClass: "step-desc" }, [
                    _vm._v("输入Google身份验证器显示的6位数字"),
                  ]),
                  _c(
                    "el-form",
                    {
                      ref: "bindForm",
                      attrs: {
                        model: _vm.bindData,
                        rules: _vm.rules,
                        "label-width": "0px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "code" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticStyle: {
                                "text-align": "center",
                                "font-size": "20px",
                                "letter-spacing": "5px",
                              },
                              attrs: {
                                placeholder: "请输入6位验证码",
                                maxlength: 6,
                                size: "large",
                              },
                              nativeOn: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.confirmBinding.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                              model: {
                                value: _vm.bindData.code,
                                callback: function ($$v) {
                                  _vm.$set(_vm.bindData, "code", $$v)
                                },
                                expression: "bindData.code",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-lock",
                                attrs: { slot: "prefix" },
                                slot: "prefix",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "button-group" },
                    [
                      _c("el-button", { on: { click: _vm.prevStep } }, [
                        _vm._v("上一步"),
                      ]),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", loading: _vm.isBinding },
                          on: { click: _vm.confirmBinding },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.isBinding ? "绑定中..." : "完成绑定") +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }